import { z } from 'zod';
import {
  strapiCertificationBaseSchema,
  strapiEducationBaseSchema,
  strapiSkillBaseSchema,
} from './base.js';

export const strapiEducationSchema = strapiEducationBaseSchema.extend({
  skills: z.array(strapiSkillBaseSchema).nullish(),
  certifications: z.array(strapiCertificationBaseSchema).nullish(),
});

export type StrapiEducationResponse = z.infer<typeof strapiEducationSchema>;
